module.exports = __webpack_public_path__ + "img/shopping.f2821b4e.png";